function Rotate(){
    jQuery(function() {
            //let animation = jQuery( ".circular-gallery ");    
            // setTimeout(function(){
            //     jQuery(animation).removeClass("animated");
            // },10000)
    });
}

export default Rotate;
